import { render, staticRenderFns } from "./recommend_item_shop.vue?vue&type=template&id=5395db5c&scoped=true&"
import script from "./recommend_item_shop.vue?vue&type=script&lang=ts&"
export * from "./recommend_item_shop.vue?vue&type=script&lang=ts&"
import style0 from "./recommend_item_shop.vue?vue&type=style&index=0&id=5395db5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395db5c",
  null
  
)

export default component.exports